export default __webpack_public_path__ + "static/media/horseshoe-bend.4138c8c74eb89b3914914bc6d11883b6.jpg";